const rankingItems = [
  { rank: 1, title: '暗夜追踪 第三季', type: '电视剧', score: '9.2', hot: '🔥 本周最热' },
  { rank: 2, title: '星际征途', type: '电影', score: '9.5', hot: '⬆ 上升3位' },
  { rank: 3, title: '声动亚洲 第五季', type: '综艺', score: '9.0', hot: '🆕 新上榜' },
  { rank: 4, title: '财阀家的小女儿', type: '韩剧', score: '9.3', hot: '⬆ 上升5位' },
  { rank: 5, title: '灵笼 终章剧场版', type: '动漫', score: '9.7', hot: '⬇ 下降2位' },
  { rank: 6, title: '向往的生活 第八季', type: '综艺', score: '9.1', hot: '— 持平' },
  { rank: 7, title: '长安十二时辰 精编版', type: '电视剧', score: '8.2', hot: '🆕 新上榜' },
];

export default function Ranking() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-white';
    if (rank === 2) return 'bg-accent-400 text-white';
    if (rank === 3) return 'bg-accent-300 text-white';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            热门排行
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            基于播放量、搜索量与用户评分的综合热度排名
          </p>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 md:gap-5 px-5 md:px-7 py-4 md:py-5 border-b border-background-200 last:border-b-0 hover:bg-background-50 transition-colors duration-200"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center text-base font-heading font-bold shrink-0 ${getRankStyle(item.rank)}`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-medium text-foreground-900 truncate">
                  {item.title}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.type}</div>
              </div>

              <div className="text-sm text-foreground-400 shrink-0 hidden sm:block">
                {item.hot}
              </div>

              <div className="flex items-center gap-1.5 shrink-0">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-accent-500"></i>
                </div>
                <span className="text-sm font-bold text-foreground-800">{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}